import Vue from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import vuetify from '@/plugins/vuetify'
import "../src/css/style.css";
import i18n from "./i18n";

Vue.use(Antd);
// Vue.use(vuetify);

// eslint-disable-next-line
BX24.init(() => {
  new Vue({
    i18n,
    Antd,
    vuetify,
    render: (h) => h(App)
  }).$mount("#app");
});
